import styled, { css } from 'styled-components';

import {
  CheckCircleOutlined,
  InfoOutlined,
  WarningAmberOutlined,
} from '@mui/icons-material';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.yoga.colors.white};
    padding: ${theme.spacing(3)} ${theme.spacing(4)};
  `}
`;

export const AssessmentDone = styled(CheckCircleOutlined)`
  ${({ theme }) => css`
    fill: ${theme.yoga.colors.success};
    height: ${theme.spacing(2)};
    width: ${theme.spacing(2)};
  `}
`;

export const AssessmentNotFinished = styled(InfoOutlined)`
  ${({ theme }) => css`
    fill: ${theme.palette.info.main};
    height: ${theme.spacing(2)};
    width: ${theme.spacing(2)};
  `}
`;

export const AssessmentPending = styled(WarningAmberOutlined)`
  ${({ theme }) => css`
    fill: ${theme.palette.error.light};
    height: ${theme.spacing(2)};
    width: ${theme.spacing(2)};
  `}
`;

export const WrapperChart = styled.div``;
